import * as React from 'react';
import styled from 'styled-components';
import {
  compose,
  space,
  color,
  layout,
  typography,
  SpaceProps,
  ColorProps,
  LayoutProps,
  TypographyProps,
} from 'styled-system';
import { nanoid } from 'nanoid';
export type IconProps = SpaceProps & ColorProps & LayoutProps & TypographyProps;
const SvgComponent = React.forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement> & {
    title?: any;
  }
>(({ title, ...props }, svgRef) => {
  const [titleId] = React.useState(() => (title ? nanoid() : undefined));
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      ref={svgRef}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="currentColor"
        d="M13 3a9 9 0 00-9 9H2.192a.5.5 0 00-.356.85l2.77 2.82a.5.5 0 00.71.004l2.828-2.82A.5.5 0 007.79 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7a6.931 6.931 0 01-4.183-1.399c-.443-.334-1.076-.342-1.468.05-.392.392-.395 1.031.037 1.377A8.935 8.935 0 0013 21a9 9 0 000-18zm-.25 5a.75.75 0 00-.75.75v3.68a1 1 0 00.49.86l3.121 1.851a.747.747 0 00.763-1.285l-2.63-1.56a.5.5 0 01-.244-.43V8.75a.75.75 0 00-.75-.75z"
      />
    </svg>
  );
});
export const IconSystemV2CourseHistory = styled(SvgComponent)<IconProps>(
  {
    flex: 'none',
    verticalAlign: 'middle',
  },
  compose(space, color, layout, typography)
);
